import React from 'react';
import { useConfig } from '../config/ConfigContext';

const ThemeProvider = ({ children }) => {
  const { config, loading } = useConfig();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-blue mx-auto mb-4"></div>
          <p className="text-gray-600 font-medium">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="app-container"
      data-theme={config?.theme?.name || 'default'}
      style={{
        '--color-primary': config?.theme?.colors?.primary || '#203E90',
        '--color-secondary': config?.theme?.colors?.secondary || '#E31419',
        '--color-accent': config?.theme?.colors?.accent || '#868686',
        '--gradient-start': config?.theme?.colors?.gradientStart || '#203E90',
        '--gradient-end': config?.theme?.colors?.gradientEnd || '#E31419',
        '--font-heading': config?.theme?.fonts?.heading || 'Playfair Display',
        '--font-body': config?.theme?.fonts?.body || 'Inter'
      }}
    >
      {children}
    </div>
  );
};

export default ThemeProvider;